// Fichas del MODELADO = lo que ofrece la SUITE + lo que cargan los PROVEEDORES.
// El cotizador y el backoffice de técnicos/proveedores leen esta misma unión.

const KEY = 'sh:stock-cache';

function clave(brand, model) {
  return `${String(brand || '').toLowerCase().trim()}|${String(model || '').toLowerCase().trim()}`;
}

export function guardarOfertaProveedor(supplierId, company, items) {
  if (typeof localStorage === 'undefined' || supplierId == null) return;
  try {
    const all = JSON.parse(localStorage.getItem(KEY) || '{}');
    all[String(supplierId)] = { id: supplierId, company: company || 'Proveedor', items: items || [], at: Date.now() };
    localStorage.setItem(KEY, JSON.stringify(all));
    try { window.dispatchEvent(new Event('sh-fichas-oferta')); } catch { /* no window */ }
  } catch { /* modo privado */ }
}

export function leerOfertasProveedores() {
  try {
    return Object.values(JSON.parse(localStorage.getItem(KEY) || '{}'));
  } catch {
    return [];
  }
}

export function fichaDesdeStock(item, company) {
  if (!item) return null;
  const stock = {
    qty: Number(item.qty_available || 0),
    supplier: company || 'Proveedor',
    updatedAt: (item.updated_at || '').slice(0, 10) || new Date().toISOString().slice(0, 10),
  };
  const id = `prov-${item.id || `${item.brand}-${item.model}`}`;
  const base = { id, brand: item.brand, model: item.model, price: Number(item.unit_price_cop || 0), origen: 'proveedor', stock };
  if (item.equipment_type === 'panel') return { ...base, wp: Number(item.wp || 0), kg: 25 };
  if (item.equipment_type === 'inverter') {
    return { ...base, kw: Number(item.kw || 0), type: 'on-grid', phase: 1, kg: 20 };
  }
  if (item.equipment_type === 'battery') return { ...base, kwh: Number(item.kwh || 0), kg: 18 };
  return null;
}

export function marcarSuite(eq) {
  if (!eq) return eq;
  const origen = eq.origen && eq.origen !== 'suite' ? eq.origen : 'alebas';
  return {
    ...eq,
    origen,
    stock: eq.stock || { qty: 0, supplier: 'Alebas' },
  };
}

/** Alebas (suite / first-party / FluxAI hardware) gana sobre proveedor externo. */
export function esFichaAlebas(eq) {
  const o = String(eq?.origen || '');
  return o === 'alebas' || o === 'suite' || o === 'first_party' || o === 'fluxai_hardware';
}

export function mezclarFichasModelo(suiteList, ofertas, tipoStock) {
  const map = new Map();
  for (const s of (suiteList || []).map(marcarSuite)) {
    map.set(clave(s.brand, s.model) || String(s.id), { ...s, prioridad: 1 });
  }
  for (const ofe of ofertas || []) {
    for (const it of ofe.items || []) {
      if (tipoStock && it.equipment_type !== tipoStock) continue;
      if (it.is_active === false) continue;
      const f = fichaDesdeStock(it, ofe.company);
      if (!f) continue;
      const k = clave(f.brand, f.model);
      const prev = map.get(k);
      if (prev && esFichaAlebas(prev)) {
        map.set(k, {
          ...prev,
          proveedorAlt: { company: ofe.company, price: f.price, stock: f.stock },
        });
        continue;
      }
      if (!prev) map.set(k, { ...f, origen: 'proveedor', prioridad: 2 });
    }
  }
  return [...map.values()].sort((a, b) => (a.prioridad || 9) - (b.prioridad || 9));
}

export function etiquetaOrigen(o) {
  if (o === 'proveedor' || o === 'proveedor_inscrito') return 'Proveedor';
  if (o === 'suite+proveedor') return 'Alebas (hay oferta externa)';
  if (o === 'fluxai_hardware') return 'FluxAI';
  return 'Alebas';
}

export function etiquetaTipo(t) {
  if (t === 'inverter') return 'Inversor';
  if (t === 'battery') return 'Batería';
  return 'Panel';
}

export function fichasUnion(suite, ofertas) {
  return [
    ...mezclarFichasModelo(suite?.panels || [], ofertas, 'panel'),
    ...mezclarFichasModelo(suite?.inverters || [], ofertas, 'inverter'),
    ...mezclarFichasModelo(suite?.batteries || [], ofertas, 'battery'),
  ];
}

function objEq(v) {
  return v && typeof v === 'object' ? v : null;
}

export function bomDeCotizacion(q) {
  if (!q) return [];
  const pld = objEq(q.payload) || {};
  const r = objEq(q.results) || objEq(pld.results) || {};
  const panel = objEq(q.panel) || objEq(pld.panel);
  const inv = objEq(q.inverter) || objEq(pld.inverter) || objEq(r.inv);
  const batt = objEq(q.battery) || objEq(pld.battery);
  const lines = [];

  const pBrand = panel?.brand || q.panel_brand || pld.panel_brand || '';
  const pModel = panel?.model || q.panel_model || pld.panel_model
    || (typeof pld.panel === 'string' ? pld.panel : '') || '';
  if (pBrand || pModel) {
    lines.push({
      tipo: 'panel',
      brand: pBrand,
      model: pModel,
      sku: panel?.id || panel?.sku || q.panel_sku,
      origen: panel?.origen || q.panel_origen,
      qty: Number(r.numPanels || q.num_panels || pld.num_panels || 1),
      price: Number(panel?.price || q.panel_price || pld.panel_price || 0),
      wp: panel?.wp,
    });
  }

  const iBrand = inv?.brand || q.inverter_brand || pld.inverter_brand || '';
  const iModel = inv?.model || q.inverter_model || pld.inverter_model || '';
  if (iBrand || iModel) {
    lines.push({
      tipo: 'inverter',
      brand: iBrand,
      model: iModel,
      qty: 1,
      price: Number(inv?.price || q.inverter_price || pld.inverter_price || 0),
      kw: inv?.kw,
    });
  }

  if (batt && (batt.brand || batt.model)) {
    lines.push({
      tipo: 'battery',
      brand: batt.brand,
      model: batt.model,
      qty: Number(batt.qty || 1),
      price: Number(batt.price || 0),
      kwh: batt.kwh,
    });
  }
  return lines;
}

export function cubrirBomConOfertas(bom, ofertas) {
  return (bom || []).map((line) => {
    if (esFichaAlebas(line) || line.fuente === 'alebas' || line.fuente === 'suite') {
      return { ...line, fuente: 'alebas', cubierto: true, unit_price_cop: line.price || 0 };
    }
    for (const ofe of ofertas || []) {
      const [hit] = cubrirBomConProveedor([line], ofe.items, ofe.company);
      if (hit?.cubierto) return hit;
    }
    return { ...line, fuente: 'alebas', cubierto: false, unit_price_cop: line.price || 0 };
  });
}

/** Oferta de venta: Alebas si la ficha es nuestra; si no, el primer proveedor que la tenga. */
export function cubrirBomPrioridadAlebas(bom, ofertas) {
  return cubrirBomConOfertas(bom, ofertas);
}

export function cubrirBomConProveedor(bom, ofertaItems, company) {
  return (bom || []).map((line) => {
    const t = line.tipo === 'inverter' ? 'inverter' : line.tipo === 'battery' ? 'battery' : 'panel';
    const hit = (ofertaItems || []).find((it) => (
      it.equipment_type === t && clave(it.brand, it.model) === clave(line.brand, line.model)
    ));
    if (hit) {
      return {
        ...line,
        fuente: 'proveedor',
        supplier: company,
        unit_price_cop: Number(hit.unit_price_cop || line.price || 0),
        qty_available: hit.qty_available,
        cubierto: true,
      };
    }
    return { ...line, fuente: 'suite', cubierto: false, unit_price_cop: line.price || 0 };
  });
}

export function itemsPoDesdeBom(cubierto) {
  return (cubierto || []).map((l) => ({
    equipment_type: l.tipo === 'inverter' ? 'inverter' : l.tipo,
    brand: l.brand,
    model: l.model,
    qty: l.qty,
    unit_price_cop: l.unit_price_cop || l.price || 0,
    line_total_cop: (l.qty || 1) * (l.unit_price_cop || l.price || 0),
    fuente: l.fuente,
  }));
}
